<template>
  <div>
    <productBanner />
    <div class="content">
      <div class="ins">
        <div class="title">药品监管大数据中心</div>
        <div class="desc">药品监管数据中台建设，搭建药品数据汇集及交换共享平台。通过对药品产业链中药品供应、生产及流通等数据进行采集、清洗、存储、计算及分析，形成标准化数据，构建数据资产库，挖掘出数据的内在价值。</div>
        <div><img src="./images/img1.png" alt=""></div>
      </div>
      <div class="img-container">
        <img src="~assets/images/products/product1.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import productBanner from 'components/product-banner'
export default {
  components: {
    productBanner
  }
}
</script>

<style lang="stylus" scoped>
.content
  padding 80px 9%
  display flex
  .ins
    flex 1
    display flex
    flex-direction column
    justify-content space-between
    .title
      color #0160B7
      font-size 30px
      line-height 70px
    .desc
      line-height 1.5
      font-size 14px
      color #333333
    img
      display block
      width 100%
  .img-container
    flex 1
    img
      width 95%
      margin-left 5%
</style>



// WEBPACK FOOTER //
// src/pages/ypjg/ypjg.vue